import React, { useEffect } from 'react'
import Head from 'next/head'

import { useSETrackEvent } from 'app/InspirationPage/hooks/useSETrackEvent'
import BuktiKarya from 'app/InspirationPage/pages/BuktiKarya'

export const BuktiKaryaPage = () => {
  const { SETrackBuktiKaryaExploreOpenIdePraktik } = useSETrackEvent()

  useEffect(() => {
    SETrackBuktiKaryaExploreOpenIdePraktik()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Head>
        <title>Ide Praktik - Ruang GTK</title>
        <meta name="description" content="Jelajahi konten praktik terbaik" />
      </Head>

      <BuktiKarya />
    </>
  )
}

// eslint-disable-next-line react/display-name
BuktiKaryaPage.Layout = ({ children }) => children

export default BuktiKaryaPage
